import client from '../client';
import type { Paylink, CreatePaylinkInput, UpdatePaylinkInput } from '../../types/paylink';
import type { ApiResponse } from '../../types/api';

export const paylinksApi = {
  list: async (storeId: string, params?: { search?: string; sort?: string; startDate?: string; endDate?: string; page?: number; limit?: number }) => {
    const res = await client.get<ApiResponse<{ paylinks: Paylink[] }>>(
      `/dashboard/${storeId}/paylinks`,
      { params },
    );
    const d = res.data.data!;
    return {
      paylinks: d.paylinks || [],
      total: (d as any).total ?? (d.paylinks?.length ?? 0),
    };
  },

  get: async (storeId: string, paylinkId: string) => {
    const res = await client.get<ApiResponse<{ paylink: Paylink }>>(
      `/dashboard/${storeId}/paylinks/${paylinkId}`,
    );
    return res.data.data!;
  },

  create: async (storeId: string, data: CreatePaylinkInput) => {
    const res = await client.post<ApiResponse<{ link: string; paylinkId: string }>>(
      `/dashboard/${storeId}/paylinks`,
      data,
    );
    return res.data.data!;
  },

  update: async (storeId: string, paylinkId: string, data: UpdatePaylinkInput) => {
    await client.patch(`/dashboard/${storeId}/paylinks/${paylinkId}`, data);
  },

  delete: async (storeId: string, paylinkId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/paylinks/${paylinkId}`);
  },

  getAnalytics: async (storeId: string, paylinkId: string) => {
    const res = await client.get<ApiResponse<{ views: number; clicks: number; conversions: number; revenue: number }>>(
      `/dashboard/${storeId}/paylinks/${paylinkId}/analytics`,
    );
    return res.data.data!;
  },
};
